//APIS
import axios from 'apis/axios'

export const postTrackerGroup = async (
  queryParameters = {},
  bodyParameters = {},
  hash,
) => {
  try {
    const response = await axios.post(
      'tracker/group/list', 
      { ...bodyParameters, hash },
    )
  
    return response
  } catch (error) {
    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}

export const postTrackerStates = async (
  queryParameters = {},
  bodyParameters = {},
  hash,
) => {
  try {
    const response = await axios.post(
      'tracker/get_states', 
      { ...bodyParameters, hash },
    )
  
    return response
  } catch (error) {
    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}

export const postTrackerList = async (
  queryParameters = {},
  bodyParameters = {},
  hash,
) => {
  try {
    const response = await axios.post(
      'tracker/list', 
      { ...bodyParameters, hash },
    )
  
    return response
  } catch (error) {
    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}

export const postTrackerCount = async (
  queryParameters = {},
  bodyParameters = {},
  hash,
) => {
  try {
    const response = await axios.post(
      'tracker/counter/value/list', 
      { ...bodyParameters, hash },
    )
  
    return response
  } catch (error) {
    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}

export const postSendCommand = async (
  queryParameters = {},
  bodyParameters = {},
  hash,
) => {
  try {
    const response = await axios.post(
      'tracker/raw_command/send', 
      { ...bodyParameters, hash },
    )
  
    return response
  } catch (error) {
    if (error.message === 'canceled') return { status: 'Canceled' }
    else if (!error.response) return { status: 'No Server Response' }
    else return error.response
  }
}